// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.gds.Point
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

export class PointBase {
  /** Do NOT invoke directly, instead use strongly typed createPointBase factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadg.Point";
  }
  initFromJson(json, deserializeContext) {
    this.initPoint(json.x, json.y);
  }
  initPoint(x, y) {
    this._x = x;
    this._y = y;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["x"] = this._x;
    retVal["y"] = this._y;
    return retVal;
  }
  get x() {
    return this._x;
  }
  set x(value) {
    this._x = value;
  }
  get y() {
    return this._y;
  }
  set y(value) {
    this._y = value;
  }
}
//# sourceMappingURL=PointBase.js.map
